// Generated by ReScript, PLEASE EDIT WITH CARE

import ConfigLoaderJs from "./configLoader.js";

var config_obj = ConfigLoaderJs;

var env = config_obj.env;

var oms_url = config_obj.oms_url;

var google_maps_api_key = config_obj.google_maps_api_key;

var cms_url = config_obj.cms_url;

var recaptcha_site_key = config_obj.google_recaptcha_api_key;

var sentry_dsn = config_obj.sentry_dsn;

var ga4_tracking_id_ae = config_obj.ga4_tracking_id_ae;

var ga4_tracking_id_bd = config_obj.ga4_tracking_id_bd;

var ga4_tracking_id_tr = config_obj.ga4_tracking_id_tr;

var ga4_tracking_id_dom = config_obj.ga4_tracking_id_dom;

var wag_url = config_obj.wag_url;

var kafka_api_url = config_obj.kafka_api_url;

var enable_all_vehicles_agreed_docs = config_obj.enable_all_vehicles_agreed_docs;

var agreed_docs_login_flag = config_obj.agreed_docs_login_flag;

var customerCMSUrl = config_obj.customerCMSUrl;

var newInitiativesUrl = config_obj.newInitiativesUrl;

var cag_url = config_obj.cag_url;

var cookie_encryption_secret = config_obj.cookie_encryption_secret;

var enable_recaptcha = config_obj.enable_recaptcha;

var moengage_config = config_obj.moengage_config;

var sfmsUrl = config_obj.sfmsUrl;

var enable_gtm = config_obj.enable_gtm;

var gtm_code = config_obj.gtm_code;

var ent_exp_ranges = config_obj.ent_exp_ranges;

var hogsmeade_url = config_obj.hogsmeade_url;

var oms_internal_url = config_obj.oms_internal_url;

var google_sheet_id = config_obj.google_sheet_id;

var desktop_location_accuracy_rollout_pct = config_obj.desktop_location_accuracy_rollout_pct;

var enable_enterprise_nudge = config_obj.enable_enterprise_nudge;

function getPnMUrl(param) {
  switch (env) {
    case "prod" :
    case "production" :
        return "https://pnm.porter.in/";
    default:
      return "https://pnm-ktor-gcp.staging-internal.porter.in/";
  }
}

var release_ts = "process.env.RELEASE_TS";

var ga_tracker_name_int = "ga_4_ssr_gcp";

var ga_tracker_name_dom = "ga_website_platform";

var internal_path = "/hjovueg7zyfjtzo";

var isrTime;

export {
  config_obj ,
  env ,
  oms_url ,
  google_maps_api_key ,
  cms_url ,
  recaptcha_site_key ,
  sentry_dsn ,
  ga4_tracking_id_ae ,
  ga4_tracking_id_bd ,
  ga4_tracking_id_tr ,
  ga4_tracking_id_dom ,
  release_ts ,
  ga_tracker_name_int ,
  ga_tracker_name_dom ,
  wag_url ,
  kafka_api_url ,
  enable_all_vehicles_agreed_docs ,
  agreed_docs_login_flag ,
  customerCMSUrl ,
  newInitiativesUrl ,
  cag_url ,
  cookie_encryption_secret ,
  enable_recaptcha ,
  moengage_config ,
  internal_path ,
  sfmsUrl ,
  enable_gtm ,
  gtm_code ,
  isrTime ,
  ent_exp_ranges ,
  hogsmeade_url ,
  oms_internal_url ,
  google_sheet_id ,
  desktop_location_accuracy_rollout_pct ,
  enable_enterprise_nudge ,
  getPnMUrl ,
}
/* config_obj Not a pure module */
